"use client";
import React from "react";
import { includes } from "lodash";

import getFindQrHandler from "@api/getFindQr/index";

import { useApi } from "@/hooks/useApi";
import { useRouter } from "next/navigation";
import { QRProps } from "@/contexts/QREditorContext/types";
import { QRCodeScanResponse } from "@/interface/api/getFindQr/types";
import { QRViewPageTemplate } from "@/templates/QRViewPageTemplate";
import { IQrViewPage } from "@/types/types";
import { QREditorAPItoDataConversor } from "@/services/ApiConversorService/QREditor";

const NOT_FOUND_MESSAGE = "not found";

export const PViewContainer = (props: IQrViewPage) => {
  const [qrData, setQrData] = React.useState<QRProps<any> | undefined>(undefined);
  const router = useRouter();

  const {
    request: requestFind,
    data: dataFind,
    error: errorFind,
  } = useApi(getFindQrHandler.getFindQr);

  const qrCodeId = props.params.qrId;

  React.useEffect(() => {
    qrCodeId && requestFind({ qrCodeId });
  }, [qrCodeId]);

  React.useEffect(() => {
    if (errorFind?.status === 400) {
      if (includes(errorFind.data.message, NOT_FOUND_MESSAGE)) router.replace("/404");
    }
  }, [errorFind]);

  React.useEffect(() => {
    if (dataFind) {
      const dataQR: QRCodeScanResponse = dataFind.data;

      setQrData(QREditorAPItoDataConversor.getQRData(dataQR));
    }
  }, [dataFind]);

  return (
    <QRViewPageTemplate
      qrData={qrData}
      language={props.params.lang}
    />
  );
};
